// 给 .anniu-box .cell-1 ~ .cell-5 添加点击事件，1/2是同一个子元素，3/4/5是同一个子元素
document.addEventListener('DOMContentLoaded', function() {
  const groupA = [1, 2]; // 对应同一个 img-1
  const groupB = [3, 4, 5]; // 对应同一个 img-3

  groupA.forEach(function(i) {
    let cell = document.querySelector('.anniu-box .cell-' + i);
   
    if (cell) {
      cell.addEventListener('click', function() {
        let imgs = document.querySelectorAll('.custom-media-item-1 img');
        
        // 如果有 img-1 类名，给他 opacity 1，其它元素 opacity 0
        if (imgs.length > 0) {
          imgs.forEach(function(img) {
            console.log(img,i);
            if (img.classList.contains(`img-${i}`)) {
              img.style.opacity = "1";
            } else {
              img.style.opacity = "0";
            }
          });
        }
      });
    }
  });

  groupB.forEach(function(i) {
    let cell = document.querySelector('.anniu-box .cell-' + i);
    if (cell) {
      cell.addEventListener('click', function() {
        let imgs = document.querySelectorAll('.custom-media-item-2 img');
        if (imgs.length > 0) {
          imgs.forEach(function(img) {
            if (img.classList.contains(`img-${i}`)) {
              img.style.opacity = "1";
            } else {
              img.style.opacity = "0";
            }
          });
        }
      });
    }
  });
});
